import { CascadiaColor, CascadiaTypographyStyle } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import { PropsOf } from "@emotion/react";
import { useMemo } from "react";
import { mergeProps } from "react-aria";
import { Header as AriaHeader } from "react-aria-components";

import { getTextStyle } from "../../../../foundations/typography/styles";
import { useColors } from "../../../../hooks/useColors";

interface Props extends PropsOf<typeof AriaHeader> {
  color?: CascadiaColor;
  textStyle?: CascadiaTypographyStyle;
}

export function _Header(props: Props) {
  const colors = useColors();

  const { textStyle, color, ...headerProps } = props;

  const className = useMemo(
    () =>
      css(
        styles.header,
        textStyle && getTextStyle(textStyle),
        color && { color: colors[color] }
      ),
    [color, colors, textStyle]
  );

  return (
    <AriaHeader
      {...mergeProps(headerProps, {
        className,
      })}
    />
  );
}

const styles = {
  header: css(
    {
      paddingTop: "var(--space-3)",
      paddingLeft: "var(--space-2)",
      paddingRight: "var(--space-2)",
      paddingBottom: "var(--space-1)",
    },
    getTextStyle("input/section-title")
  ),
};
